<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
    width="45%"
  >
    <dialog-header
      slot="title"
      :title="titles"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <div :style="{height:  isEdit && !isPermiss ? '30vh': '60vh'}">
       <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <el-form
          ref="formCenter"
          :rules="rules"
          :model="formInfo"
          :label-position="'right'"
          :label-width="$t('carManagement.buttonLabelWidth')"
        >
          <!--基本信息-->
          <!-- <h3 class="car_title">{{this.$t('system.role.basicInfo')}}</h3> -->
           <vue-linetitle 
           :title="$t('system.role.basicInfo')"
           :icon-config="{isIcon: true }">
              <el-row style="padding-top: 5px">
                <el-col :span="13">
                  <el-form-item :label="$t('system.role.name')+ '：'" prop="roleName">
                    <el-input v-model="formInfo.roleName" :maxlength="100" clearable :disabled="isEdit&&isPermiss" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item :label="$t('public.note') + '：'">
                <el-input
                  v-model="formInfo.remark"
                  :maxlength="500"
                  :rows="3"
                  :autosize="{ minRows: 3, maxRows: 3}"
                  resize="none"
                  :placeholder="$t('public.note')"
                  type="textarea"
                  :disabled="isEdit&&isPermiss"
                  :show-word-limit="true"
                />
              </el-form-item>
           </vue-linetitle>
          
          <!--授权功能菜单-->
          <vue-linetitle  
          v-if="(isPermiss||!isEdit)" 
          :title="$t('system.role.menu')"
          :icon-config="{isIcon: true }">
            <el-tree
              ref="tree"
              :data="treeData"
              :expand-on-click-node="false"
              :default-expand-all="true"
              :default-checked-keys="defaultCheckedKeys"
              :check-strictly="true"
              node-key="functionId"
              show-checkbox
              v-if="(isPermiss||!isEdit)">
              <div slot-scope="{ data }" class="custom-region" style="flex:1">
                  <span class="tree-span">{{ data.functionName }}</span>
                </div>
            </el-tree>
          </vue-linetitle>

          
        </el-form>
      </el-col>
    </el-row>
    </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{$t('public.cancel')}}</el-button>
      <el-button type="primary" @click="submitForm">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// request
import {
  addRole,
  editRole,
  setRoleMenu,
  getMenuTree, // type 0：开发 1：v2x管理员所有菜单 2：车队管理员 
  getRoleMenuTree
} from "@/api/system/role"
import { partialForm } from "@/mixins/partialForm"
export default {
  name: "roleAddUpdateDialog",
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isPermiss: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => []
    }
  },
  computed: {
    lang(){
      return this.$store.getters.language
    },
    role() {
      return this.$store.getters.roles[0]
    },
    titles(){
      if(this.isPermiss && this.isEdit) {
        return this.lang === 'en' ? 'Permission':'权限设置'
      }else{
        return !this.isEdit? this.$t('system.role.create') : this.$t('system.role.update')
      }
    }
    // role(){
    //   return this.$store.getters.
    // }
  },
  data() {
    const validateroleName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t("system.role.error")))
      }
    }
    return {
      formInfo: {},
      treeData: [],
      defaultCheckedKeys: [],
      rules: {
        roleName: [
          { required: true, trigger: "blur", validator: validateroleName },
          { trigger: "change", validator: validateroleName }
        ]
      }
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if(e1){
          if(this.isEdit){
            this.formInfo = { ...this.data }
          }  else {
             this.formInfo = { ...this.role,...{roleName: ''} }
          }
          this._getTreeData()
        }
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      this.formInfo = {}
      this.treeData = []
      this.defaultCheckedKeys = []
      this.$emit("update:visibles", false)
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    // 新增
    _Add(postData) {
      addRole(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t("public.createSuccess"),
            duration: 2 * 1000
          })
          this.$emit("add-complete")
          this.closeDialog()
        }
      })
    },
    // 编辑
    _Update(postData, id) {
      editRole(postData, id).then(({ data }) => {
        if (data.code === 0) {
          this.$emit("update-complete")
          this.closeDialog()
        }
      })
    },
    //设置角色权限菜单
    _setMenu(postData, id) {
      setRoleMenu(postData, id).then(({ data }) => {
        if (data.code === 0) {
          this.$emit("update-complete")
          this.closeDialog()
        }
      })
    },
    // 点击提交
    submitForm() {
      const formcenter = this.checkForm({
        formName: "formCenter",
        formList: ["roleName"]
      })
      if (!formcenter) {
        return
      }
      const { roleId, ...postData } = this.formInfo
      if (this.isPermiss) {
        postData.menuIds = this.$refs.tree.getCheckedKeys()
      }
      if (!this.isEdit) {
        this._Add(postData)
      } else if (this.isEdit && !this.isPermiss) {
        // eslint-disable-next-line no-unused-vars
        const { $index,weight,isSys, dataScope, ...putdata } = postData
        // putdata.id = roleId;
        this._Update({id: roleId,data: putdata})
      } else if (this.isEdit && this.isPermiss) {
        this._setMenu({ id: roleId, data: postData.menuIds })
      }
    },
    //获取菜单树
    _getTreeData() {
      const type = this._getRoleType()
      if(!type) return
      getMenuTree(type).then(({ data }) => {
        if (data.code === 0) {
          this.treeData = data.data || []
          return this.treeData
        }
      }).then(()=>{
        if (this.isPermiss && this.isEdit) {
          getRoleMenuTree({ id: this.formInfo.roleId })
            .then(({ data }) => {
              if (data.code === 0) {
                this.defaultCheckedKeys = this._getTreeLight(data.data || [])
              }
            })
        }
      })
    },
    _getRoleType(){
      const { weight } = this.formInfo
      return ~~(weight / 100) - 1
    },
    _getTreeLight(list) {
      let result = []
      if (list.length === 0) return result
      ergodicPage(list)
      function ergodicPage(list) {
        list.forEach(item => {
          if (item.functionId) {
            result.push(item.functionId)
          }
          if (item.children && item.children.length > 0) {
            ergodicPage(item.children)
          }
        })
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.car_title {
  color: #409eff;
  padding: 0 0 10px 0;
  margin-top: 0;
  font-size: 14px !important;
  border-bottom: 1px dashed #dcdfe6;
}
</style>